/*
 * Copyright (c) 2026. Tooling Team
 */

export const normalizeMedDomainDetailRecord = (record) => ({
  ...record,
  groupId: record.groupid ?? "",
  dataSource: record.datasrc ?? "",
  clientDsId: record.client_ds_id ?? null,
  rxTab: record.rxtab ?? "",
  localDesc: record.localdescription ?? "",
  numRxs: record.num_rxs ?? null,
  hmkDcc: record.hmk_dcc ?? "",
  hgmkDcc: record.hgmk_dcc ?? "",
  predictedDcc: record.predicteddcc ?? null,
  mlNeedsReview: record.ml_needsreview ?? null,
});
